import { Ready } from '../../Store/Types';
import { fromEmpty, nothing } from 'maybeasy';
import {
  SingleSelectionField,
  findField,
} from '../../../../../../../../Resource/FormTemplates/Types';

const findUserGroupId = (state: Ready) =>
  findField('user_group_id', 'single-selection', state.template.fields);

const hasSelectableOptions = (field: SingleSelectionField) => {
  switch (field.options.kind) {
    case 'options-list-and-rel':
    case 'options-list':
      return fromEmpty(field.options.options);
    case 'options-rel':
      return nothing();
  }
};

export const userGroupOptions = (state: Ready) =>
  findUserGroupId(state).andThen(hasSelectableOptions);
